import { Alert, Typography } from '@execonline-inc/execonline-ui';
import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import { T } from '../../../../../../Translations';
import Button from '../../../../../Form/Button';

interface Props {
  creating: () => void;
  possibleShareUrlCount: number;
}

function ShareUrlBanner({ possibleShareUrlCount, creating }: Props) {
  return when(possibleShareUrlCount > 0, true)
    .map(() => (
      <div className="max-w-clientPortalMaxWidth mx-auto px-2.5 lg:px-12 my-6">
        <Alert
          status="warning"
          variant="outlined"
          icon
          radius="md"
          data-intercom-target="shareable-links-new-links-banner"
        >
          <div className="flex w-full flex-wrap items-center gap-x-4 gap-y-2">
            <div className="min-w-0 flex-1">
              <Typography variant="bodyMedium" fontWeight="medium">
                <T kind="Add New Course Deep Links" />
              </Typography>
              <Typography variant="bodySmall" className="text-muted-foreground">
                <T
                  kind="Your collection has been updated. {{count}} new Course Deep Link can be added for this collection."
                  count={possibleShareUrlCount}
                />
              </Typography>
            </div>
            <Button
              className="rounded-md bg-primary px-6 py-2 text-primary-foreground"
              value="Add Deep Links"
              onClick={creating}
              type="button"
            />
          </div>
        </Alert>
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ShareUrlBanner);
